import React from 'react';
import { ArrowLeft, Building2, User, Globe, Shield, Cookie, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../data/mock';

const LegalPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      {/* Header */}
      <header className="bg-white dark:bg-gray-800 shadow-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-primary-blue hover:text-primary-cyan transition-colors"
            data-testid="back-to-home-link"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Retour à l'accueil</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-8">
          Mentions Légales
        </h1>

        <div className="space-y-8">
          {/* Éditeur du site */}
          <section className="bg-white dark:bg-gray-800 rounded-2xl p-6 sm:p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-primary-blue/10 dark:bg-primary-blue/20 rounded-lg flex items-center justify-center">
                <Building2 className="w-5 h-5 text-primary-blue" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Éditeur du site
              </h2>
            </div>
            <div className="text-gray-600 dark:text-gray-300 space-y-2">
              <p><strong>Raison sociale :</strong> {companyInfo.name}</p>
              <p><strong>Forme juridique :</strong> Entreprise individuelle</p>
              <p><strong>SIRET :</strong> 823 028 923 00022</p>
              <p><strong>Adresse :</strong> {companyInfo.address}</p>
              <p><strong>Téléphone :</strong> {companyInfo.phone}</p>
              <p><strong>Email :</strong> {companyInfo.email}</p>
            </div>
          </section>

          {/* Directeur de publication */}
          <section className="bg-white dark:bg-gray-800 rounded-2xl p-6 sm:p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-primary-cyan/10 dark:bg-primary-cyan/20 rounded-lg flex items-center justify-center">
                <User className="w-5 h-5 text-primary-cyan" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Directeur de la publication
              </h2>
            </div>
            <p className="text-gray-600 dark:text-gray-300">
              <strong>Nom :</strong> GOUJON Yohan
            </p>
          </section>

          {/* Hébergement */}
          <section className="bg-white dark:bg-gray-800 rounded-2xl p-6 sm:p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-green-500/10 dark:bg-green-500/20 rounded-lg flex items-center justify-center">
                <Globe className="w-5 h-5 text-green-500" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Hébergement
              </h2>
            </div>
            <div className="text-gray-600 dark:text-gray-300 space-y-2">
              <p><strong>Hébergeur :</strong> OVH SAS</p>
              <p><strong>Adresse :</strong> 2 rue Kellermann, 59100 Roubaix, France</p>
              <p><strong>RCS :</strong> Lille Métropole 424 761 419 00045</p>
              <p><strong>Site web :</strong> <a href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer" className="text-primary-blue hover:text-primary-cyan">www.ovhcloud.com</a></p>
            </div>
          </section>

          {/* Propriété intellectuelle */}
          <section className="bg-white dark:bg-gray-800 rounded-2xl p-6 sm:p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-purple-500/10 dark:bg-purple-500/20 rounded-lg flex items-center justify-center">
                <Shield className="w-5 h-5 text-purple-500" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Propriété intellectuelle
              </h2>
            </div>
            <div className="text-gray-600 dark:text-gray-300 space-y-4">
              <p>
                L'ensemble du contenu de ce site (textes, images, graphismes, logo, icônes, etc.) 
                est la propriété exclusive de {companyInfo.name}, à l'exception des marques, logos 
                ou contenus appartenant à d'autres sociétés partenaires ou auteurs.
              </p>
              <p>
                Toute reproduction, distribution, modification, adaptation, retransmission ou publication, 
                même partielle, de ces différents éléments est strictement interdite sans l'accord 
                exprès par écrit de {companyInfo.name}.
              </p>
            </div>
          </section>

          {/* Données personnelles */}
          <section className="bg-white dark:bg-gray-800 rounded-2xl p-6 sm:p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-orange-500/10 dark:bg-orange-500/20 rounded-lg flex items-center justify-center">
                <Cookie className="w-5 h-5 text-orange-500" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Protection des données personnelles
              </h2>
            </div>
            <div className="text-gray-600 dark:text-gray-300 space-y-4">
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la 
                loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, 
                de suppression et d'opposition aux données personnelles vous concernant.
              </p>
              <p>
                Ce site utilise des cookies à des fins de mesure d'audience (Google Analytics, 
                Microsoft Clarity) uniquement avec votre consentement préalable. Vous pouvez 
                gérer vos préférences via la bannière de cookies.
              </p>
              <p>
                Pour exercer vos droits ou pour toute question relative à la protection de vos 
                données personnelles, vous pouvez nous contacter :
              </p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Par email : <a href={`mailto:${companyInfo.email}`} className="text-primary-blue hover:text-primary-cyan">{companyInfo.email}</a></li>
                <li>Par courrier : {companyInfo.address}</li>
              </ul>
            </div>
          </section>

          {/* Cookies */}
          <section className="bg-white dark:bg-gray-800 rounded-2xl p-6 sm:p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-yellow-500/10 dark:bg-yellow-500/20 rounded-lg flex items-center justify-center">
                <Cookie className="w-5 h-5 text-yellow-500" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Politique de cookies
              </h2>
            </div>
            <div className="text-gray-600 dark:text-gray-300 space-y-4">
              <p>
                Ce site utilise des cookies pour améliorer l'expérience utilisateur et analyser 
                le trafic. Les cookies utilisés sont :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>Google Analytics :</strong> Cookies de mesure d'audience permettant 
                  de collecter des informations anonymes sur la navigation (pages visitées, 
                  durée des visites, etc.)
                </li>
                <li>
                  <strong>Microsoft Clarity :</strong> Outil d'analyse du comportement des 
                  visiteurs (cartes de chaleur, enregistrements de sessions anonymisés)
                </li>
                <li>
                  <strong>Cookie de consentement :</strong> Mémorise votre choix concernant 
                  l'acceptation ou le refus des cookies
                </li>
              </ul>
              <p>
                Ces cookies ne sont déposés qu'après votre consentement explicite via la 
                bannière de cookies. Vous pouvez à tout moment modifier vos préférences en 
                supprimant les cookies de votre navigateur.
              </p>
            </div>
          </section>

          {/* Limitation de responsabilité */}
          <section className="bg-white dark:bg-gray-800 rounded-2xl p-6 sm:p-8 shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
              Limitation de responsabilité
            </h2>
            <div className="text-gray-600 dark:text-gray-300 space-y-4">
              <p>
                Les informations contenues sur ce site sont aussi précises que possible et le 
                site est périodiquement remis à jour, mais peut toutefois contenir des 
                inexactitudes, des omissions ou des lacunes.
              </p>
              <p>
                {companyInfo.name} ne pourra être tenu responsable des dommages directs et 
                indirects causés au matériel de l'utilisateur, lors de l'accès au site, et 
                résultant soit de l'utilisation d'un matériel ne répondant pas aux spécifications 
                techniques requises, soit de l'apparition d'un bug ou d'une incompatibilité.
              </p>
            </div>
          </section>

          {/* Contact */}
          <section className="bg-gradient-to-r from-primary-blue to-primary-cyan rounded-2xl p-6 sm:p-8 text-white">
            <h2 className="text-xl font-semibold mb-4">
              Une question ?
            </h2>
            <p className="mb-6 opacity-90">
              Pour toute question concernant ces mentions légales ou le fonctionnement du site, 
              n'hésitez pas à nous contacter.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={`tel:${companyInfo.phone.replace(/\./g, '')}`}
                className="inline-flex items-center justify-center gap-2 bg-white/20 hover:bg-white/30 px-6 py-3 rounded-lg transition-colors"
                data-testid="legal-phone-link"
              >
                <Phone className="w-5 h-5" />
                {companyInfo.phone}
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="inline-flex items-center justify-center gap-2 bg-white/20 hover:bg-white/30 px-6 py-3 rounded-lg transition-colors"
                data-testid="legal-email-link"
              >
                <Mail className="w-5 h-5" />
                {companyInfo.email}
              </a>
            </div>
          </section>
        </div>

        {/* Last update */}
        <p className="text-center text-gray-500 dark:text-gray-400 text-sm mt-12">
          Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
        </p>
      </main>
    </div>
  );
};

export default LegalPage;
